import { render, staticRenderFns } from "./EventsIndex.vue?vue&type=template&id=ccaf1246&scoped=true&"
import script from "./EventsIndex.vue?vue&type=script&lang=js&"
export * from "./EventsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf1246",
  null
  
)

export default component.exports